module.exports = __webpack_public_path__ + "img/video-player/love@2x-bc12c727d17071dec2232f6562d57804.png";